import { AnalyticsAPI } from '@core/api';
import { SupportedEntitlements } from '@core/models/entitlements';
import { Organization } from '@core/models/organization';
import { useEntitlements } from '@hooks/useEntitlements';
import { useQuery } from '@tanstack/react-query';

type Props = {
  org?: Organization;
};

export function useAnomaliesByOrg({ org }: Props) {
  const entitlements = useEntitlements();
  const orgId = org?.id;

  return useQuery({
    queryKey: ['anomalies-by-org', { orgId }],
    queryFn: async () => {
      const { data } = await AnalyticsAPI.get<{
        [key: string]: { anomalies_quantity: number; anomalies_area: number };
      }>(`/anomalies/org/${orgId}`);
      return data;
    },
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    enabled: !!orgId && entitlements.has(SupportedEntitlements.ANOMALY_DETECTION),
  });
}
